<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">材料领用申请</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">
          <material-use ref="create" :userData="userData" :formByFather="form"></material-use>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments ref="attachments" style="margin-left:-10px;" :arr="attachmentArr" :type='50'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item-by-custom ref="approval" :defaultApprovalUsers="defaultApprovalUsers" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item-by-custom>
            <!-- 审批
            <approval-item ref="approval" :approvalUsers="approvalUsers.c50" :selectArr="selectArr" :approvalSetDep="approvalSetDep"></approval-item> -->

          </div>


          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitMaterial()" class="form-btn" type="success">确认提交使用材料申请
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  // import approvalUsers from '@/Mixins/approvalUsers'
  import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

  import Attachments from '@/components/Attachments'
  import ApprovalItem from '@/components/ApprovalItem'

  import MaterialUse from '@/page/form/materialUse'
  export default {
    components: {
      ApprovalItemByCustom,
      MaterialUse,
      ApprovalItem,
      Attachments,
    },
    // mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        formLoading: false,
        form: {
          houseId: '',
          projectId: '',
          customer: '',
          materials: [],
          json: true,
        },
        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      if (this.$route.params.houseId && this.$route.params.houseId != 0) {
        this.form.houseId = this.$route.params.houseId / 1
      }
      if (this.$route.params.projectId) {
        this.form.projectId = this.$route.params.projectId / 1
      }

      // 编辑
      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
        this.formLoading = true
        this.getApplyInfo()
      }
    },
    methods: {
      // 获取原审批表内容
      getApplyInfo() {
        ajax.get('/storage/material/use/info/' + this.form.applyId, {}, (res) => {
          this.applyInfo = res.vo

          this.form = this.applyInfo
          this.form.applyId = this.form.flow.applyId
          this.form.json = true

          let _materials = []
          for (var i = 0; i < this.form.materialUse.length; i++) {
            let _material = this.form.materialUse[i]
            let material = {
              material: {
                name: _material.name,
                unit: {
                  name: _material.unitName,
                  id: _material.unitId,
                },
                number: _material.number,
              },
              amount: _material.stockNum,
            }
            _materials.push({
              material: material,
              amount: _material.amount,
              materialId: _material.materialId,
            })
          }
          console.log(_materials)
          this.form.materials = _materials

          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []

          this.selectArr = this.form.flow.approvals.map(item => item.user)
          this.formLoading = false
        })
      },
      // 提交使用材料申请单
      SubmitMaterial() {
        this.form = this.$refs.create.getFromData()

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        if (!this.form.approvalUserIds) {
          this.$message.error('审批人员不能一个都不选择')
          return
        }
        this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        let _url = !this.form.applyId ? '/storage/material/use' : '/storage/material/use/edit?applyId=' + this.form
          .applyId

        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          if (!this.form.applyId) {
            this.$message.success("提交使用材料申请成功，请耐心等待领导审批")
          } else {
            this.$message.success("修改使用材料申请成功，请耐心等待领导审批")
          }
          this.$router.push('/Storage/MaterialUseList/' + this.form.houseId)
        }, (res) => {
          this.formLoading = false
        })
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/page/storage/materialUse.vue